import {action, computed, computedFn, pluralize, _} from '@api'
import {FlexLayoutStore} from '@stores'
import {IJsonModel, IJsonBorderNode, FlexLayout, IJsonTabNode} from '@flexlayout'
import {CatalogInstanceChildStore, CatalogStore} from '@stores/catalog'
import {FlexComponentName, ICatalogRootTabJson} from '.'

export type FlexLayoutPresetName = 'collapsed' | 'left-sidebar' | 'qa' | 'dev' | 'pdf'

export class FlexLayoutPresetsStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore, public store: FlexLayoutStore) {
    super(catalog)
  }

  @computed get defaultModel(): IJsonModel {
    return (
      {
        global: {
          // tabEnableFloat: true,
          //tabEnableRename: false,
          borderBarSize: 28,
          // tabSetHeaderHeight: 26,
          tabSetTabStripHeight: 34,
          tabSetAutoSelectTab: true,
          tabSetEnableTabStrip: true,
          splitterSize: 3,
          //tabSetEnableMaximize: false,
          tabEnableRename: true
        },
        borders: this.defaultBorders,
        layout: {
          type: 'row',
          children: [
          ]
        }
      }
    )
  }

  get model() { return this.store.model}

  // @computed get flexLayoutBorderItem(): IJsonTabNode {
  //   return {
  //     type: 'tab',
  //     enableClose: false,
  //     name: `Layout`,
  //     id: 'flexLayoutSettings',
  //     enableRename: false,
  //     component: 'flexLayoutSettings'
  //   }
  // }

  @computed get catalogItemDetailsBorderItem(): IJsonTabNode {
    const {catalog} = this
    return {
      type: 'tab',
      name: `Item Details`,
      enableClose: false,
      id: 'catalogItemDetails',
      component: 'catalogItemDetails',
      sortIndex: 0
    }
  }

  @computed get aggregationBorderItem() {
    return {
      type: 'tab',
      enableClose: false,
      name: `Aggregations`,
      id: 'catalogAggregateDetails',
      component: 'catalogAggregateDetails',
      sortIndex: 1
    }
  }

  @computed get pdfOptionsBorderItem(): IJsonTabNode {
    return {
      type: 'tab',
      // enableClose: false,
      name: 'PDF Options',
      id: 'pdfOptions',
      enableClose: false,
      component: 'pdfOptions',
      sortIndex: 4
    }
  }

  @computed get changeHistoryBorderItem() {
    return {
      type: 'tab',
      enableClose: false,
      name: `Change History`,
      id: 'change-log-tool-window',
      component: 'change-log-tool-window',
      sortIndex: 3
    }
  }
  get borderJson(): Omit<IJsonBorderNode, 'location'> {
    return {
      type: 'border',
      show: true,
      selected: 0,
      children: []
    }
  }

  @action resetModelToDeveloper = () => {
    this.resetModelToDefault()
  }

  @action resetModelToQA = () => {
    this.resetModelToDefault()
  }

  @computed get leftBorder(): IJsonBorderNode {
    return {
      type: 'border',
      location: 'left',
      size: 250,
      minSize: 100,
      children: [],
      // barSize: BORDER_BAR_SIZE,
    }
  }

  @computed get rightBorder(): IJsonBorderNode {
    return {
      type: 'border',
      location: 'right',
      size: 250,
      minSize: 100,
      children: []
      // barSize: BORDER_BAR_SIZE,
    }
  }

  @computed get librariesBorderTab() : IJsonTabNode {
    return {
      type: 'tab',
      // enableClose: false,
      id: 'libraries',
      name: `${this.stores.strings.libraries}`,
      enableRename: false,
      enableDrag: false,
      enableClose: false,
      component: 'libraries',
      sortIndex: 0
    }
  }

  @computed get filtersBorderTab(): IJsonTabNode{
    return {
      id: 'filters',
      type: 'tab',
      // enableClose: false,
      enableRename: false,
      name: `${this.stores.strings.filters}`,
      enableClose: false,
      component: 'filters',
      sortIndex: 1
    }
  }

  @computed get cardTab(): ICatalogRootTabJson {
    return {
      type: 'tab',
      component: 'catalog',
      config: {
        settings: {
          catalog: {viewMode: 'card'}
        }
      }
    }
  }

  @computed get tableTab(): ICatalogRootTabJson {
    return {
      type: 'tab',
      name: this.catalog.title,
      component: 'catalog',
      config: {
        settings: {
          catalog: {viewMode: 'table'}
        }
      }
    }
  }

  @computed get pdfTab(): ICatalogRootTabJson {
    return {
      type: 'tab',
      name: this.catalog.title,
      component: 'catalog',
      config: {
        settings: {catalog: {viewMode: 'pdf'}}
      }
    }
  }

  @computed get googleSearchTab(): IJsonTabNode {
    return {
      type: 'tab',
      name: 'Google',
      component: 'iframe',
      config: {
        settings: {
          url: 'https://www.google.com/webhp?igu=1'
        }
      }
    }
  }

  @computed get c8Tab(): IJsonTabNode {
    return {
      type: 'tab',
      name: 'C8',
      component: 'c8',
      config: {}
    }
  }

  @computed get vipBuyingBoardTab(): IJsonTabNode {
    return {
      type: 'tab',
      name: 'Buying Session',
      component: 'vipBuying',
      enableRenderOnDemand: false,
      config: {}
    }
  }

  @computed get defaultBorders(): Array<IJsonBorderNode> {
    const {leftBorder} = this

    const borders: Array<IJsonBorderNode | false> = [
      leftBorder,

      /**
       * Moved to {@see FlexLayoutStore.autorun_addSidebarIdIfMissing}
        */
      // {
      //   ...leftBorder,
      //   children: [
      //     flexLayoutTab,
      //     librariesTab,
      //     filtersTab,
      //   ].filter(_.identity)
      // },
      // {
      //   type: 'border',
      //   location: 'bottom',
      //   size: 30,
      //   minSize: 30,
      //   children: [
      //     {
      //       type: 'row',
      //       name: `Footer`,
      //       enableClose: false,
      //       component: 'CatalogFooter'
      //     }
      //   ]
      // },
      /*detailLoc == 'sidebar' &&*/ {
        type: 'border',
        location: 'right',
        size: 250,
        // selected: 1,
        children: []
        //   this.catalogItemDetailsTab,
        //   this.aggregationTab
        // ].filter(_.identity)
      }
    ]

    return borders.filter(_.identity) as Array<IJsonBorderNode>
  }

  @computed get jiraTabset() {
    return {
      type: 'tabset',
      weight: .25,
      enableMaximize: false,
      tabLocation: 'bottom',
      children: [
        {
          type: 'tab',
          name: 'Current Sprint',
          config: {
            jiraPreset: 'current-sprints'
          },
          component: 'Jira'
        },
        {
          type: 'tab',
          name: 'Assigned to Me',
          config: {
            jiraPreset: 'assigned-to-me'
          },
          component: 'Jira'
        },
        {
          type: 'tab',
          name: 'Recently Changed',
          component: 'Jira',
          config: {
            jiraPreset: 'recently-changed'
          }
        }
      ]
    }
  }

  @action onResetToEmptyLayout = async () => {
    console.log(`Reset flex layout to empty`)
    const {store, cardTab, catalog} = this,
      {settings, stores: {nav: {updateQueryParams}}} = store
    store.modelJson = _.cloneDeep(this.defaultModel)
    store.modelJson.layout.children = [
      {
        type: 'tabset',
        children: [{...cardTab}]
      }
    ]
    settings.model = null
    // settings.preset = null
    const r = await store.stores.reports.createReport()
  }

  @action resetModelToDefault = () => {
    console.log(`Reset flex layout to default`)
    const {store} = this,
      {settings} = store
    store.modelJson = _.cloneDeep(this.defaultModel)
    settings.model = null
    // settings.preset = null
  }

  createKnownElement = (id: FlexComponentName) : IJsonTabNode => {
    const {filtersBorderTab, librariesBorderTab, changeHistoryBorderItem, catalogItemDetailsBorderItem, pdfOptionsBorderItem, aggregationBorderItem} = this
    switch (id) {
      case 'filters':
        return filtersBorderTab
      case 'libraries':
        return librariesBorderTab
      // case 'flexLayoutSettings':
      //   return flexLayoutBorderItem
      case 'catalogItemDetails':
        return catalogItemDetailsBorderItem
      case 'pdfOptions':
        return pdfOptionsBorderItem
      case 'catalogAggregateDetails':
        return aggregationBorderItem
      case 'change-log-tool-window':
        return changeHistoryBorderItem

      default:
        throw new Error(`NYI - createKnownElement(${id})`)
        return null

    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/FlexLayoutPresets.ts